import { render, staticRenderFns } from "./video_test.vue?vue&type=template&id=1ce6644c&scoped=true"
import script from "./video_test.vue?vue&type=script&lang=js"
export * from "./video_test.vue?vue&type=script&lang=js"
import style0 from "./video_test.vue?vue&type=style&index=0&id=1ce6644c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce6644c",
  null
  
)

export default component.exports